import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextHighlighted } from '@playbookux/playbook-web-core';
import typeEntity from '../../../constants/entity-type';
import Card from '../../card-highlight';
import { formatEntityType } from '../../../utils/format-entity-type';

const ReportCard = (props) => {
  const {
    handleClick,
    highlight,
    isSelectable,
    onCardClick,
    searchHighlights,
    selected,
  } = props;

  const [showPreview, setShowPreview] = useState(false);

  const {
    searchable,
    searchableType,
    projectId,
  } = highlight || {};

  const {
    createdAt,
    tagHighlights = [],
    name,
    project,
    rawText = '',
  } = searchable;

  const url = `projects/${projectId}/reports`;
  const cardType = formatEntityType(searchableType, '');

  const handleShowPreviewText = () => {
    setShowPreview((prev) => !prev);
  };

  return (
    <Card
      cardType={cardType}
      createdAt={createdAt}
      isSelectable={isSelectable}
      onCardClick={onCardClick}
      onClick={() => handleClick(null, typeEntity.REPORT, url)}
      projectName={project.name}
      selected={selected}
      tagHighlights={tagHighlights}
      userName={name}
    >
      <TextHighlighted
        tagHighlights={tagHighlights}
        text={rawText || ''}
        searchHighlights={searchHighlights}
        showPreview={showPreview}
        onShowPreviewText={handleShowPreviewText}
      />
    </Card>
  );
};

ReportCard.propTypes = {
  handleClick: PropTypes.func,
  isSelectable: PropTypes.bool,
  selected: PropTypes.bool.isRequired,
  highlight: PropTypes.shape({
    searchable: PropTypes.shape({
      id: PropTypes.string,
      createdAt: PropTypes.string,
      tagHighlights: PropTypes.oneOfType([PropTypes.array]),
      name: PropTypes.string,
      project: PropTypes.shape({
        name: PropTypes.string,
      }),
      rawText: PropTypes.string,
    }),
    searchableType: PropTypes.string,
    projectId: PropTypes.string,
  }),
  searchHighlights: PropTypes.arrayOf(PropTypes.shape({
    charEnd: PropTypes.number,
    charStart: PropTypes.number,
    text: PropTypes.string,
  })),
  onCardClick: PropTypes.func,
};

ReportCard.defaultProps = {
  handleClick: null,
  isSelectable: false,
  highlight: PropTypes.shape({
    searchable: PropTypes.shape({
      id: '',
      createdAt: '',
      tagHighlights: [],
      name: '',
      project: PropTypes.shape({
        name: '',
      }),
      rawText: '',
    }),
    searchableType: '',
    projectId: '',
  }),
  searchHighlights: [],
  onCardClick: () => {},
};

export default ReportCard;
